export enum StatusEnum {
  LOADING = 0,
  SUCCESS = 1,
  ERROR = 2,
  NOT_ALLOWED = 3
}
